import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Orders({ outline, ...props }: IconProps): JSX.Element {
  return outline ? <Orders.Outline {...props} /> : <Orders.Solid {...props} />;
}

Orders.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M13.75 9.7V7.68C13.35 7.68 13.03 7.36 13.03 6.98V4.57C13.03 4.25 12.76 4 12.44 4H5.79C3.7 4 2 5.65 2 7.68V10.12C2 10.3 2.08 10.48 2.21 10.61C2.35 10.74 2.53 10.82 2.73 10.82C3.46 10.82 4.02 11.33 4.02 11.99C4.02 12.69 3.45 13.24 2.74 13.25C2.34 13.25 2 13.53 2 13.92V16.33C2 18.36 3.7 20 5.78 20H12.44C12.76 20 13.03 19.74 13.03 19.43V17.4C13.03 17 13.35 16.69 13.75 16.69V14.87C13.35 14.87 13.03 14.55 13.03 14.17V10.41C13.03 10.02 13.35 9.7 13.75 9.7"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon-outline"
        />
        <path
          d="M19.98 11.99C19.98 12.69 20.56 13.24 21.26 13.25C21.66 13.25 22 13.53 22 13.91V16.33C22 18.36 20.31 20 18.22 20H15.07C14.75 20 14.48 19.75 14.48 19.43V17.4C14.48 17 14.16 16.69 13.75 16.69V14.87C14.16 14.87 14.48 14.55 14.48 14.17V10.41C14.48 10.02 14.16 9.7 13.75 9.7V7.68C14.16 7.68 14.48 7.36 14.48 6.98V4.57C14.48 4.25 14.75 4 15.07 4H18.22C20.31 4 22 5.64 22 7.67V10.04C22 10.23 21.92 10.41 21.79 10.54C21.65 10.67 21.47 10.75 21.27 10.75C20.56 10.75 19.98 11.31 19.98 11.99"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon-outline"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Orders.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          opacity="0.4"
          d="M13.75 9.7V7.68C13.35 7.68 13.03 7.36 13.03 6.98V4.57C13.03 4.25 12.76 4 12.44 4H5.79C3.7 4 2 5.65 2 7.68V10.12C2 10.3 2.08 10.48 2.21 10.61C2.35 10.74 2.53 10.82 2.73 10.82C3.46 10.82 4.02 11.33 4.02 11.99C4.02 12.69 3.45 13.24 2.74 13.25C2.34 13.25 2 13.53 2 13.92V16.33C2 18.36 3.7 20 5.78 20H12.44C12.76 20 13.03 19.74 13.03 19.43V17.4C13.03 17 13.35 16.69 13.75 16.69V14.87C13.35 14.87 13.03 14.55 13.03 14.17V10.41C13.03 10.02 13.35 9.7 13.75 9.7"
          className="icon-secondary"
        />
        <path
          d="M19.98 11.99C19.98 12.69 20.56 13.24 21.26 13.25C21.66 13.25 22 13.53 22 13.91V16.33C22 18.36 20.31 20 18.22 20H15.07C14.75 20 14.48 19.75 14.48 19.43V17.4C14.48 17 14.16 16.69 13.75 16.69V14.87C14.16 14.87 14.48 14.55 14.48 14.17V10.41C14.48 10.02 14.16 9.7 13.75 9.7V7.68C14.16 7.68 14.48 7.36 14.48 6.98V4.57C14.48 4.25 14.75 4 15.07 4H18.22C20.31 4 22 5.64 22 7.67V10.04C22 10.23 21.92 10.41 21.79 10.54C21.65 10.67 21.47 10.75 21.27 10.75C20.56 10.75 19.98 11.31 19.98 11.99"
          className="icon-primary"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
